const IMAGES = {
    kuwaitinput: require('./kuwaitinput.svg').default,
    enabill: require('./enabill.svg').default,
    union: require('./union2.svg').default,
    newsPaper: require('./newsPaper.svg').default,
    giftPaper: require('./gift2.svg').default,
    dialpad: require('./Dialpad2.svg').default,
    time: require('./time2.svg').default,
    enabillLogoDec: require('./EnabilDec.svg').default,
    enabillLogo: require('./Enabill-logo.svg').default,
    knet: require('./kent_icon.svg').default,
    cash: require('./cash_icon_green.svg').default,
    masterCard: require('./mastercardHd.svg').default,
    visa: require('./visaCardHd.svg').default,
    applePay: require('./apple-pay.svg').default,
    split: require('./slip.svg').default,
    card: require('./credit.svg').default,
    invoicBg: require('./invoicBackground.svg').default,
    storeManager: require('./Users.svg').default,
    manager: require('./Managers.svg').default,

}

export default IMAGES;

